module.exports = __webpack_public_path__ + "Mark-Simonson-Proxima-Nova-Alt-Black-webfont.c47c63d8f301bb81337b.ttf";


//////////////////
// WEBPACK FOOTER
// /builds/applied-technologies/apt-lab/digitalbank-frontend-projects/digitalbank-web/src/styles/fonts/ProximaNova/Mark-Simonson-Proxima-Nova-Alt-Black-webfont.ttf
// module id = ../../../../../src/styles/fonts/ProximaNova/Mark-Simonson-Proxima-Nova-Alt-Black-webfont.ttf
// module chunks = main styles